// Copyright 2026 The Gitea Authors. All rights reserved.
// SPDX-License-Identifier: MIT
import {createApp} from 'vue';

export async function initFederationUserSettings() {
  const el = document.querySelector<HTMLElement>('#federation-user-settings');
  if (!el) return;

  const pageData = window.config.pageData.federationUserSettings;
  if (!pageData) return;

  try {
    const {default: FederationUserSettings} = await import('../components/FederationUserSettings.vue');
    createApp(FederationUserSettings, {pageData}).mount(el);
    el.classList.remove('is-loading');
  } catch (err) {
    console.error('FederationUserSettings failed to load', err);
    el.textContent = 'Federation settings failed to load';
  }
}
